import i18n from '@/i18n';

export const GenderTypeLabels: string[] = [
  i18n.global.t('rooms.toiletTypes.women'),
  i18n.global.t('rooms.toiletTypes.men'),
  i18n.global.t('rooms.toiletTypes.neutral'),
];
